module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "peer-assessment-questions"
  }, [_c('p', {
    staticClass: "pl-subheading"
  }, [_vm._v("Peer Feedback Questions")]), _vm._v(" "), _vm._l((_vm.getCurrentRT.peer_assessment_questions), function(question, index) {
    return _c('ul', {
      staticClass: "question-list-item"
    }, [_c('li', {
      staticClass: "row middle-xs",
      staticStyle: {
        "padding-left": "16px",
        "min-height": "60px"
      }
    }, [(_vm.editing_question_index !== index || !_vm.editing_question) ? _c('span', {
      staticClass: "col-xs-8 pl-body-2"
    }, [_vm._v("\n        " + _vm._s(index + 1) + ". " + _vm._s(question.question) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.editing_question && _vm.editing_question_index === index) ? _c('div', {
      staticClass: "col-xs-8 pl-body-2 flex"
    }, [_c('span', [_vm._v(" " + _vm._s(index + 1) + ". ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.peer_assessment_questions[_vm.editing_question_index].question),
        expression: "peer_assessment_questions[editing_question_index].question"
      }],
      ref: "edit-question",
      refInFor: true,
      staticClass: "edit-rt-question-input",
      domProps: {
        "value": (_vm.peer_assessment_questions[_vm.editing_question_index].question)
      },
      on: {
        "blur": function($event) {
          return _vm.savePeerQuestion()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.peer_assessment_questions[_vm.editing_question_index], "question", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 tc"
    }, [_c('toggle-button', {
      attrs: {
        "value": question.is_active,
        "color": "#72ccd7",
        "labels": true
      },
      on: {
        "change": function($event) {
          return _vm.toggleQuestionStatus($event, index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1"
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.editPeerQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), (question.is_custom) ? _c('div', {
      staticClass: "col-xs-1"
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      nativeOn: {
        "click": function($event) {
          return _vm.removePeerQuestion(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-list-container",
    staticStyle: {
      "padding": "13px 0"
    }
  }, [_c('div', {
    staticClass: "row middle-xs",
    staticStyle: {
      "padding-left": "9px"
    }
  }, [_c('pl-input', {
    staticClass: "col-xs-10",
    attrs: {
      "type": "text",
      "labelText": "Question"
    },
    model: {
      value: (_vm.peer_question_new),
      callback: function($$v) {
        _vm.peer_question_new = $$v
      },
      expression: "peer_question_new"
    }
  }), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary pl-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.addPeerQuestion.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row end-xs close-button"
  }, [_c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('closeTab')
      }
    }
  }, [_vm._v(" Close ")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-490d23da!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/roundtableSettingsTabs/guidanceQuestionsSettingsTab.vue
// module id = 1316
// module chunks = 61